var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchangeArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ongd2yoeua",
    d: "M0 0h15.204v7.187H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eyt4o1ut4c",
    d: "M0 0h15.204v7.187H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.917)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nax3axu86b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ongd2yoeua"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.923 1.46H4.836V.768A.777.777 0 0 0 3.559.181L.273 3.006A.773.773 0 0 0 .27 4.181l3.29 2.823a.776.776 0 0 0 1.276-.588v-.691h6.384a3.987 3.987 0 0 0 3.984-3.984.282.282 0 0 0-.281-.281z",
    fill: "#84898D",
    mask: "url(#nax3axu86b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 7.602 3.593)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8aekktf2jd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eyt4o1ut4c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.923 1.46H4.836V.768A.777.777 0 0 0 3.559.181L.273 3.006A.773.773 0 0 0 .27 4.181l3.29 2.823a.776.776 0 0 0 1.276-.588v-.691h6.384a3.987 3.987 0 0 0 3.984-3.984.282.282 0 0 0-.281-.281z",
    fill: "#84898D",
    mask: "url(#8aekktf2jd)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeArrow);
export default __webpack_public_path__ + "static/media/exchange-arrow.fc6f9c73db2a6fdf068b7735fd355a91.svg";
export { ForwardRef as ReactComponent };